import { render, staticRenderFns } from "./UseTag.vue?vue&type=template&id=1c08c30f&"
import script from "./UseTag.vue?vue&type=script&lang=js&"
export * from "./UseTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports